import { Sun, Moon } from 'lucide-react'
import { useTheme } from '../contexts/ThemeContext'

export default function ThemeToggle() {
  const { theme, toggleTheme } = useTheme()

  return (
    <button
      onClick={toggleTheme}
      className="flex items-center space-x-2 sm:space-x-3 px-2 sm:px-4 py-2 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors duration-200"
      aria-label="Toggle theme"
    >
      <div className="flex items-center space-x-1 sm:space-x-2">
        {theme === 'light' ? (
          <Sun className="h-4 w-4 text-yellow-500" />
        ) : (
          <Moon className="h-4 w-4 text-orange-400" />
        )}
        <span className="text-xs sm:text-sm font-medium text-gray-700 dark:text-gray-300">
          <span className="sm:hidden">
            {theme === 'light' ? 'CISO' : 'Practitioner'}
          </span>
          <span className="hidden sm:inline">
            {theme === 'light' ? 'CISO Mode' : 'Practitioner Mode'}
          </span>
        </span>
      </div>
      
      <div className="relative">
        <div className={`w-8 sm:w-10 h-5 sm:h-6 rounded-full transition-colors duration-200 ${
          theme === 'dark' ? 'bg-primary-600' : 'bg-gray-300'
        }`}>
          <div className={`absolute top-0.5 sm:top-1 w-3 sm:w-4 h-3 sm:h-4 bg-white rounded-full transition-transform duration-200 ${
            theme === 'dark' ? 'translate-x-4 sm:translate-x-5' : 'translate-x-0.5 sm:translate-x-1'
          }`} />
        </div>
      </div>
    </button>
  )
}